import type { ReactNode } from 'react';
import { Link } from 'wouter';
import { ArrowRight, Menu, X } from 'lucide-react';
import { useState } from 'react';
import { STANDARD_LOGO_SRC } from '@/lib/brandAssets';

type PublicSiteShellProps = {
  children: ReactNode;
  compact?: boolean;
};

export function PublicSiteShell({ children, compact = false }: PublicSiteShellProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="public-site">
      <header className="public-header">
        <Link href="/" className="public-brand" aria-label="The Standard home">
          <img
            src={STANDARD_LOGO_SRC}
            alt="The Standard"
            className="public-brand-logo public-brand-logo-header"
          />
        </Link>

        <nav className="public-nav" aria-label="Primary navigation">
          <Link href="/#features" className="public-nav-extra">The System</Link>
          <Link href="/membership">Membership</Link>
          <Link href="/results">Results</Link>
          <Link href="/blog">Journal</Link>
          <Link href="/login" className="public-nav-signin">Member Sign In</Link>
          <a href="https://coachfe.coach/apply?lane=standard">Apply for Coaching</a>
          <Link href="/membership" className="public-button public-button-primary public-button-small">
            Start Free Trial <ArrowRight size={15} />
          </Link>
        </nav>

        <button
          type="button"
          className="public-menu-button"
          onClick={() => setOpen(value => !value)}
          aria-expanded={open}
          aria-label={open ? 'Close menu' : 'Open menu'}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </header>

      {open && (
        <nav className="public-mobile-nav" aria-label="Mobile navigation">
          <Link href="/#features" onClick={() => setOpen(false)}>The System</Link>
          <Link href="/membership" onClick={() => setOpen(false)}>Membership</Link>
          <Link href="/results" onClick={() => setOpen(false)}>Results</Link>
          <Link href="/blog" onClick={() => setOpen(false)}>Journal</Link>
          <Link href="/login" onClick={() => setOpen(false)}>Member Sign In</Link>
          <a href="https://coachfe.coach/apply?lane=standard" onClick={() => setOpen(false)}>Apply for Coaching</a>
          <Link href="/membership" onClick={() => setOpen(false)} className="public-button public-button-primary">
            Start Free Trial <ArrowRight size={16} />
          </Link>
        </nav>
      )}

      <main className={compact ? 'public-main public-main-compact' : 'public-main'}>{children}</main>
    </div>
  );
}

export function PublicFooter() {
  return (
    <footer className="public-footer">
      <Link href="/" className="public-brand public-brand-footer" aria-label="The Standard home">
        <img
          src={STANDARD_LOGO_SRC}
          alt="The Standard"
          className="public-brand-logo public-brand-logo-footer"
          loading="lazy"
        />
      </Link>
      <nav aria-label="Footer navigation">
        <Link href="/membership">Membership</Link>
        <Link href="/results">Results</Link>
        <Link href="/blog">Journal</Link>
        <Link href="/login">Member Sign In</Link>
        <Link href="/privacy">Privacy</Link>
        <Link href="/terms">Terms</Link>
        <a href="https://platform.fatsecret.com">Powered by fatsecret Platform API</a>
      </nav>
    </footer>
  );
}
